import React from 'react';

/**
 * Faixa sutil exibida no topo das páginas quando o sistema está em Modo Demo.
 * Uso: {isDemo && <DemoBanner />}
 */
const DemoBanner = () => (
  <div
    className="d-flex align-items-center gap-2 px-3 py-2 rounded-2 mb-4"
    style={{
      background: 'rgba(13, 202, 240, 0.08)',
      border: '1px solid rgba(13, 202, 240, 0.25)',
      fontSize: '0.8rem',
      color: '#0dcaf0',
    }}
  >
    <i className="bi bi-eye"></i>
    <span>
      <strong>MODO DEMO</strong> — Os dados exibidos são fictícios. Nenhuma ação afeta um sistema real.
    </span>
  </div>
);

export default DemoBanner;
